import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '@services/auth.service';
import { DefaultModuleService } from '@services/default-module.service';
import { SystemDataService } from '@services/system-data.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  isMobileMenuVisible = false;

  constructor(
    readonly authService: AuthService,
    readonly systemDataService: SystemDataService,
    private readonly defaultModuleService: DefaultModuleService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    this.defaultModuleService.handleRouterEvents();
    this.injectEdubotScript();
  }

  private injectEdubotScript(): void {
    const scriptHtml = environment.edubotScript;
    if (!scriptHtml) {return;}

    const parsed = new DOMParser().parseFromString(scriptHtml, 'text/html');
    const template = parsed.querySelector('script');
    if (!template) {return;}

    const script = this.document.createElement('script');
    Array.from(template.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
    this.document.head.appendChild(script);
  }

  hideMobileMenu(): void {
    this.isMobileMenuVisible = false;
  }

  showMobileMenu(): void {
    this.isMobileMenuVisible = true;
  }
}
